import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const ProtectedRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    user
  } = useUser();
  if (!user) {
    return <Navigate to="/login" replace data-id="element-291" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;